import { useState, useEffect, useCallback } from 'react';
import { Sun, Moon } from 'lucide-react';

export const ThemeToggle = () => {
  const [dark, setDark] = useState(() => {
    if (typeof window === 'undefined') return false;
    return localStorage.getItem('theme') === 'dark';
  });

  const apply = useCallback((isDark) => {
    document.documentElement.setAttribute('data-theme', isDark ? 'dark' : 'light');
    localStorage.setItem('theme', isDark ? 'dark' : 'light');
  }, []);

  useEffect(() => { apply(dark); }, [dark, apply]);

  return (
    <button
      className="theme-toggle"
      data-testid="theme-toggle"
      onClick={() => setDark(d => !d)}
      aria-label={dark ? 'Switch to light mode' : 'Switch to dark mode'}
    >
      {dark ? <Sun strokeWidth={1.5} /> : <Moon strokeWidth={1.5} />}
    </button>
  );
};
